import { render, staticRenderFns } from "./assign_categories.vue?vue&type=template&id=db249676"
import script from "./assign_categories.vue?vue&type=script&lang=js"
export * from "./assign_categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db249676')) {
      api.createRecord('db249676', component.options)
    } else {
      api.reload('db249676', component.options)
    }
    module.hot.accept("./assign_categories.vue?vue&type=template&id=db249676", function () {
      api.rerender('db249676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/assign_categories.vue"
export default component.exports